import { Component, OnInit } from '@angular/core';
import { EmperorCardHeaderColor } from '@boldpenguin/emperor-presentational';
import { SelectorWrapperService } from '@boldpenguin/emperor-services';
import { WebSocketConnectionState } from '@boldpenguin/sdk';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'emperor-bp-sdk-socket-disconnection-dialog',
  templateUrl: './bp-sdk-socket-disconnection-dialog.component.html',
  styleUrls: ['./bp-sdk-socket-disconnection-dialog.component.scss'],
})
export class BpSdkSocketDisconnectionDialogComponent implements OnInit {
  shouldDisplayDialog$: Observable<boolean>;
  theme = EmperorCardHeaderColor.PRIMARY;

  constructor(private selectorWrapperService: SelectorWrapperService) {}

  ngOnInit(): void {
    this.shouldDisplayDialog$ = this.selectorWrapperService
      .getSdkWebSocketConnectionState$()
      .pipe(map(state => state === WebSocketConnectionState.Disconnected));
  }
}
